import React, { useEffect, useRef } from "react"
import { useInView } from "framer-motion"

type propsType = {
  children: JSX.Element | JSX.Element[]
}

const LoadInView = ({ children }: propsType) => {
  const ref = useRef(null)
  const isInView = useInView(ref, {
    // once: true
  })

  useEffect(() => {}, [isInView])

  return (
    <div ref={ref}>
      <div
        style={{
          transform: isInView ? "none" : "translateY(-100px)",
          opacity: isInView ? 1 : 0,
          transition: "all .7s",
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default LoadInView
